import styled from 'styled-components'

export const ContentStyled = styled.div`
  padding: 10px;
`
export const FormStyled = styled.div``
export const PreviewStyled = styled.div``
